import { useCallback, useEffect, useRef, useState } from "react";

export const useFetchLocal = (fetchCall = null, successMsg = '', errorMsg = '') => {
  const [data, setData] = useState({
    error: false,
    message: null,
    response: null,
    success: false,
    loading: false,
  });
  const isMounted = useRef(false);
  const requestId = useRef(0);

  const handleFetch = useCallback(
    async (...args) => {
      const currentRequestId = ++requestId.current;
      setData((prevData) => ({ ...prevData, loading: true, success: false }));
      try {
        const res = await fetchCall(...args);
        if (isMounted.current && currentRequestId === requestId.current) {
          setData({
            error: false,
            message: res.length === 0 ? 'No se encontró información' : successMsg,
            response: res,
            success: true,
            loading: false,
          });
        }
      } catch (err) {
        if (isMounted.current && currentRequestId === requestId.current) {
          setData({
            error: true,
            message: err?.message || errorMsg,
            response: null,
            success: false,
            loading: false,
          });
        }
      }
    },
    [fetchCall, successMsg, errorMsg]
  );

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  return [[data.response, data.loading, data.success, data.error, data.message], handleFetch];
};
